import React from 'react';
import { Stack, Typography, Avatar } from '@mui/material';
import { Box } from '@mui/system';
import { Person } from '@mui/icons-material';

import { ReviewContainer, RatingContainer } from './index.styles';
import { getSocialIcon, SocialMediaNames } from '../../helpers/socialIcons';
import { getDateHumanReadable } from '../../helpers';
import { getFormattedUSNumber, getFormattedNumberOfSubscriber, formatNumber } from '../../utilities';
import { ALL_SOCIAL_MEDIA } from '../../utilities/constants';

interface IReview {
    imageUrl: string;
    brandName: string;
    review: string;
    socialMedia: any[];
    reviewPostDate: string;
    rating: number;
    noMargin?: boolean;
    singleShow?: boolean;
    isStaticCard?: boolean;
    isDateTimeShow?: boolean;
    totalCompensation?: number;
}

function Review(reviewProps: IReview) {
 
   const {
        imageUrl,
        brandName,
        review,
        socialMedia,
        rating,
        reviewPostDate,
        isDateTimeShow,
        noMargin,
        singleShow,
       isStaticCard,
       totalCompensation
    } = reviewProps;

    return (
        <ReviewContainer
            sx={{
                // Todo: need for future reference
                // m: noMargin ? 0 : "auto",
                maxWidth: noMargin ? "auto" : "602px",
                minWidth: singleShow ? "602px" : "auto",
            }}
        >
            <Stack>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <div className='img-container'>
                            <img src={imageUrl} alt={brandName} />
                        </div>
                        <Typography
                            sx={{
                                display: "inline-block",
                                fontSize: "18px",
                                fontWeight: "700",
                                lineHeight: "18px",
                                color: "primary.main",
                                marginLeft: "0.813rem",
                                textTransform: "capitalize",
                            }}
                        >
                            {brandName}
                        </Typography>
                    </div>
                    <Box>
                        <RatingContainer value={rating} readOnly />
                    </Box>
                </Box>
                {review ? (
                    <Box
                        sx={{
                            position: "relative",
                            marginTop: "2rem",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "36px",
                                lineHeight: "0",
                                position: "absolute",
                                display: "inline-block",
                                fontWeight: "700",
                            }}
                        >
                            “
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: "18px",
                                lineHeight: "18px",
                                fontStyle: "italic",
                                marginLeft: "2rem",
                                transform: "translateY(-1rem)",
                                color: "claraPalette.gray1",
                                fontWeight: "400",
                                width: "90%",
                            }}
                            component='div'
                        >
                            {review}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: "36px",
                                lineHeight: "24px",
                                position: "absolute",
                                bottom: "10px",
                                right: "0",
                                display: "inline-block",
                                fontWeight: "700",
                            }}
                        >
                            ”
                        </Typography>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            position: "relative",
                            marginTop: "1.3rem",
                        }}
                    ></Box>
                )}
                {isStaticCard || !totalCompensation ? (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                fontSize: "0.875rem",
                                mr: "0.75rem",
                                lineHeight: "1.5rem",
                                color: "claraPalette.darkGray",
                                fontWeight: "400",
                            }}
                        >
                            Price
                        </Typography>
                        <Box>
                            {socialMedia.map((i) => {
                                const { _id, socialMediaName } = i;
                                const splitSocialMediaName =
                                    socialMediaName.split(" ");
                                if (
                                    socialMediaName ===
                                        ALL_SOCIAL_MEDIA[
                                            "UGC Photo"
                                        ] ||
                                    socialMediaName ===
                                        ALL_SOCIAL_MEDIA["UGC Video"]
                                ) {
                                    splitSocialMediaName[0] =
                                        splitSocialMediaName
                                            .join("")
                                            .toLowerCase();
                                }
                                return (
                                    <Box
                                        key={_id}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "claraPalette.darkGray",
                                            ml: "0.25rem",
                                        }}
                                    >
                                        {getSocialIcon(
                                            splitSocialMediaName[0] ===
                                                "TikTok"
                                                ? "Tiktok"
                                                : splitSocialMediaName[0],
                                            "20px"
                                        )}
                                        <Typography
                                            sx={{
                                                fontSize: "0.875rem",
                                                fontWeight: "400",
                                                ml: "0.50rem",
                                                mr: "1.5rem",
                                                color: "claraPalette.gray1",
                                                lineHeight: "2",
                                                height: "1.5rem",
                                            }}
                                        >
                                            {splitSocialMediaName[1] === "Sponsorship" || splitSocialMediaName[1] === "fee" ? splitSocialMediaName[0] : splitSocialMediaName[1] || ""}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                        <Box>
                            {socialMedia.map((i) => {
                                const { _id, pricePerPost } = i;
                                return (
                                    <Box
                                        key={_id}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "claraPalette.darkGray",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "1rem",
                                                fontWeight: "700",
                                                ml: "1rem",
                                                color: "claraPalette.darkGray",
                                            }}
                                        >
                                            $
                                            {getFormattedUSNumber(
                                                pricePerPost
                                            )}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                        <Box sx={{ ml: "1rem" }}>
                            {socialMedia.map((i) => {
                                const {
                                    _id,
                                    followers,
                                    socialMediaName,
                                } = i;
                                const splitSocialMediaName =
                                    socialMediaName.split(" ");
                                return (
                                    <Box
                                        key={_id}
                                        sx={{
                                            height: "24px",
                                            display: "flex",
                                            alignItems: "center",
                                            color: "#828282",
                                            fontSize: "14px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        {followers.max < 2000
                                            ? `Less than ${formatNumber(
                                                  2000
                                              )} Followers`
                                            : `${getFormattedNumberOfSubscriber(
                                                  followers
                                              )} ${
                                                  splitSocialMediaName[0] ===
                                                  SocialMediaNames.Youtube
                                                      ? "Subscribers"
                                                      : "Followers"
                                              }`}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                    columnGap: "4px",
                                    marginTop: "0.11rem"
                            }}
                        >
                            <Typography
                                fontWeight='700'
                                fontSize='16px'
                            >
                                Total Compensation
                            </Typography>
                            <Typography
                                fontWeight='700'
                                fontSize='16px'
                            >
                                {`$${totalCompensation}`}
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                    display: "flex",
                                alignContent:'center',
                                fontSize: "0.875rem",
                                mr: "0.50rem",
                                ml: "1.5rem",
                                lineHeight: "1.8rem",
                                color: "claraPalette.gray1",
                                fontWeight: "400",
                            }}
                        >
                            For
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Box>
                                {socialMedia.map((i) => {
                                    const { _id, socialMediaName,numberOfPosts } =
                                        i;
                                    const splitSocialMediaName =
                                        socialMediaName.split(" ");
                                    if (
                                        socialMediaName ===
                                            ALL_SOCIAL_MEDIA[
                                                "UGC Photo"
                                            ] ||
                                        socialMediaName ===
                                            ALL_SOCIAL_MEDIA[
                                                "UGC Video"
                                            ]
                                    ) {
                                        splitSocialMediaName[0] =
                                            splitSocialMediaName
                                                .join("")
                                                .toLowerCase();
                                    }
                                    return (
                                        <Box
                                            key={_id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                color: "claraPalette.darkGray",
                                                ml: "0.25rem",
                                            }}
                                        >
                                          {numberOfPosts && <Typography
                                                sx={{
                                                    color: "claraPalette.gray1",
                                                    mr: '4px',
                                                    ml: `${numberOfPosts === 10?'-3.5px':'4px'}`,
        
                                                    lineHeight: "1.8rem"
                                                }}
                                            >
                                                {numberOfPosts}
                                            </Typography>}
                                            {getSocialIcon(
                                                splitSocialMediaName[0] ===
                                                    "TikTok"
                                                    ? "Tiktok"
                                                    : splitSocialMediaName[0],
                                                "20px"
                                            )}
                                            <Typography
                                                sx={{
                                                    fontSize:
                                                        "0.875rem",
                                                    fontWeight: "400",
                                                    ml: "0.35rem",
                                                    mr: "1.5rem",
                                                    color: "claraPalette.gray1",
                                                    lineHeight: "1.5rem",
                                                    height: "1.5rem",
                                                }}
                                            >
                         {splitSocialMediaName[1] === "Sponsorship" || splitSocialMediaName[1] === "fee" ? splitSocialMediaName[0] : splitSocialMediaName[1] || ""}
                                            </Typography>
                                        </Box>
                                    );
                                })}
                            </Box>
                            <Box>
                                {socialMedia.map((i) => {
                                    const { _id } = i;
                                    return (
                                        <Box
                                            key={_id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                color: "claraPalette.darkGray",
                                            }}
                                        >
                                        </Box>
                                    );
                                })}
                            </Box>
                            <Box sx={{ ml: "1rem" }}>
                                {socialMedia.map((i) => {
                                    const {
                                        _id,
                                        followers,
                                        socialMediaName,
                                    } = i;
                                    const splitSocialMediaName =
                                        socialMediaName.split(" ");
                                    return (
                                        <Box
                                            key={_id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                color: "#828282",
                                                fontSize: "14px",
                                                fontWeight: "700",
                                                lineHeight: "1rem",
                                                height: "1.8rem",
                                            }}
                                        >
                                            {followers.max > 20000000
                                                ? `20m+ Followers`
                                                : `${getFormattedNumberOfSubscriber(
                                                      followers
                                                  )} ${
                                                      splitSocialMediaName[0] ===
                                                      SocialMediaNames.Youtube
                                                          ? "Subscribers"
                                                          : "Followers"
                                                  }`}
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>
                    </Box>
                )}
                <Box
                    sx={{
                        marginTop: "1.4rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 18,
                                height: 18,
                                display: "inline-block",
                            }}
                        >
                            <Person
                                sx={{
                                    width: 18,
                                    height: 18,
                                    background: "#828282",
                                }}
                            />
                        </Avatar>
                        <Typography
                            sx={{
                                display: "inline-block",
                                fontWeight: "700",
                                fontSize: "12px",
                                lineHeight: "18px",
                                fontStyle: "italic",
                                marginLeft: "1rem",
                                color: "claraPalette.gray1",
                                textTransform: "capitalize",
                            }}
                        >
                            Anonymous
                        </Typography>
                    </Box>
                    {isDateTimeShow && (
                        <Typography
                            sx={{
                                color: "claraPalette.gray1",
                                fontStyle: "italic",
                                fontSize: "12px",
                            }}
                        >
                            Posted on{" "}
                            {getDateHumanReadable(reviewPostDate)}
                        </Typography>
                    )}
                </Box>
            </Stack>
        </ReviewContainer>
    );
}

export default Review;
